// extracted by mini-css-extract-plugin
export var deleteIcon = "_r4-5";
export var deleteOption = "_r4-3";
export var divider = "_r4-2";
export var downloadIcon = "_r4-4";
export var drawer = "_r4-0";
export var drawerFooter = "_r4-6";
export var drawerOpen = "_r4-1";
export var highlighted = "_r4-7";
export var lighterHighlight = "_r4-8";